import { CreateApiResponse, FetchApiResponse, FilterMetadata } from "redux/types";

export enum ExcessRefundTypes {
  FETCH_EXCESS_REFUND_REQUEST = "@@auth/FETCH_EXCESS_REFUND_REQUEST",
  FETCH_EXCESS_REFUND_SUCCESS = "@@auth/FETCH_EXCESS_REFUND_SUCCESS",
  FETCH_EXCESS_REFUND_ERROR = "@@auth/FETCH_EXCESS_REFUND_ERROR",

  FETCH_EXCESS_REFUND_BY_EXTERNAL_ID_REQUEST = "@auth/FETCH_EXCESS_REFUND_BY_EXTERNAL_ID_REQUEST",
  FETCH_EXCESS_REFUND_BY_EXTERNAL_ID_SUCCESS = "@auth/FETCH_EXCESS_REFUND_BY_EXTERNAL_ID_SUCCESS",
  FETCH_EXCESS_REFUND_BY_EXTERNAL_ID_FAIL = "@auth/FETCH_EXCESS_REFUND_BY_EXTERNAL_ID_FAIL",

  RESET = "@auth/RESET"
}

export type ExcessRefundActionDispatch = {
  type: ExcessRefundTypes.FETCH_EXCESS_REFUND_REQUEST | ExcessRefundTypes.FETCH_EXCESS_REFUND_BY_EXTERNAL_ID_REQUEST | ExcessRefundTypes.RESET;
  payload: any;
};

export type ExcessRefundRead = {
  repaymentsRequestId: string;
};

export type ExcessRefundReadReducerDispatch = {
  type: ExcessRefundTypes.FETCH_EXCESS_REFUND_REQUEST | ExcessRefundTypes.FETCH_EXCESS_REFUND_SUCCESS | ExcessRefundTypes.FETCH_EXCESS_REFUND_ERROR;

  payload: {
    data?: FetchApiResponse<ExcessRefundRead>;
    error?: string;
  };
};

export type ExcessRefundReducerDispatch = {
  type:
    | ExcessRefundTypes.FETCH_EXCESS_REFUND_REQUEST
    | ExcessRefundTypes.FETCH_EXCESS_REFUND_SUCCESS
    | ExcessRefundTypes.FETCH_EXCESS_REFUND_ERROR
    | ExcessRefundTypes.FETCH_EXCESS_REFUND_BY_EXTERNAL_ID_REQUEST
    | ExcessRefundTypes.FETCH_EXCESS_REFUND_BY_EXTERNAL_ID_SUCCESS
    | ExcessRefundTypes.FETCH_EXCESS_REFUND_BY_EXTERNAL_ID_FAIL
    | ExcessRefundTypes.RESET;
  payload: {
    data?: FetchApiResponse<ExcessRefund>;
    error?: string;
  };
};

// used by reducer
export type ExcessRefundReduxState = {
  loading?: boolean;
  data?: FetchApiResponse<ExcessRefund>;
  error?: string | null;
};

export type ExcessRefundByIdRedux = {
  loading?: boolean;
  data?: CreateApiResponse<ExcessRefund>;
  error?: string | null;
};

export type ExcessRefund = {
  status: string;
  externalId: string;
  sourceFlowType: string;
  repaymentRequestId: string;
  programmName: object;
  borrowerName: object;
  exposureOn: string;
  refundDate: string;
  refundAmount: number;
  utr?: string | null;
  failureReason?: string | null;
};

// used by saga
export type ExcessRefundFetchRequest = {
  payload: FilterMetadata;
  type: string;
};
